import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Fa from 'react-fontawesome';
import { delay } from 'lodash';
import { MenuItem } from 'react-bootstrap';
import { sendLoginLink } from '../../SetupActions';

class SendLoginLink extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sending: false,
      sent: false,
    };
    this.sendLink = this.sendLink.bind(this);
  }

  sendLink() {
    if (!this.state.sending) {
      this.setState({ sending: true }, () => {
        this.props.dispatch(sendLoginLink(this.props.organization._id, this.props.user._id))
          .then(
            (info) => {
              const el = (<div>A login link email has been sent to <code>{info.email}</code></div>);
              this.context.addNotification(el, { type: 'success', autoClose: true });
              this.setState({ sent: true }, () => {
                delay(() => {
                  this.setState({ sending: false, sent: false });
                }, 1000);
              });
            },
            (e) => {
              const el = (<div>{e?.data?.message || e.message || 'Error occurs'}</div>);
              this.context.addNotification(el, { type: 'error', autoClose: true });
              this.setState({ sending: false });
            }
          );
      });
    }
  }

  render() {
    const {
      disabled,
    } = this.props;
    const { sending, sent } = this.state;

    let label = 'Send Login Link';
    let icon = 'sign-in';

    let spin = sending;

    if (sending) {
      label = 'Sending';
      icon = 'spinner';
    }
    if (sent) {
      label = 'Sent!';
      icon = 'check-circle';
      spin = false;
    }

    return (
      <MenuItem disabled={(disabled || sending)} onClick={this.sendLink}>
        <Fa name={icon} spin={spin} /> {label}
      </MenuItem>
    );
  }
}

SendLoginLink.propTypes = {
  dispatch: PropTypes.func.isRequired,
  user: PropTypes.shape({
    _id: PropTypes.string.isRequired,
  }).isRequired,
  disabled: PropTypes.bool,
  organization: PropTypes.shape({}).isRequired,
};
SendLoginLink.defaultProps = {
  PropTypes: false,
};
SendLoginLink.contextTypes = {
  addNotification: PropTypes.func.isRequired,
};

function mapStateToProps() {
  return {
  };
}
export default connect(mapStateToProps)(SendLoginLink);
